(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-nav-link"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.scProductCompareLinksReady) return;
  window.scProductCompareLinksReady = true;
  const prepareLink = link => {
    const current = new URL(window.location.href);
    const destination = new URL(link.href, current);
    if (destination.origin !== current.origin) return;
    // Preserve the destination's view and current Shopify preview context.
    new Set(current.searchParams.keys()).forEach(key => {
      if (['view', 'variant', 'sc_compare', 'sc_diff'].includes(key) || destination.searchParams.has(key)) return;
      current.searchParams.getAll(key).forEach(value => destination.searchParams.append(key, value));
    });
    destination.searchParams.set('sc_compare', link.dataset.scProductCompare);
    link.href = destination.href;
  };
  const initialize = root => root.querySelectorAll('[data-sc-product-compare]').forEach(prepareLink);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-sc-product-compare]');
    if (link) prepareLink(link);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-video-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-video-player')) {
  customElements.define('sc-video-player', class extends HTMLElement {
    connectedCallback() {
      if (this.scReady) return;
      this.scReady = true;
      this.idle = this.querySelector('[data-sc-video-idle]');
      this.mount = this.querySelector('[data-sc-video-mount]');
      this.trigger = this.querySelector('[data-sc-video-trigger]');
      this.status = this.querySelector('[data-sc-video-status]');
      this.desktopTemplate = this.querySelector('template[data-sc-video-desktop]');
      this.mobileTemplate = this.querySelector('template[data-sc-video-mobile]');
      if (!this.mount || !this.trigger || (!this.desktopTemplate && !this.externalSource())) return;
      this.trigger.hidden = false;
      this.trigger.addEventListener('click', () => this.play());
    }
    disconnectedCallback() {
      this.pause();
    }
    externalSource() {
      const id = this.dataset.videoId || '';
      if (this.dataset.provider === 'youtube' && /^[a-zA-Z0-9_-]{11}$/.test(id)) {
        const url = new URL(`https://www.youtube-nocookie.com/embed/${id}`);
        url.search = 'autoplay=1&playsinline=1&rel=0';
        return url.href;
      }
      if (this.dataset.provider === 'vimeo' && /^\d+$/.test(id)) {
        const url = new URL(`https://player.vimeo.com/video/${id}`);
        url.search = 'autoplay=1&playsinline=1&dnt=1';
        return url.href;
      }
      return '';
    }
    pauseOthers() {
      const group = this.closest('[data-sc-media-group]') || this.parentElement;
      group?.querySelectorAll('sc-video-player').forEach(player => {
        if (player !== this && typeof player.pause === 'function') player.pause();
      });
      group?.querySelectorAll('video').forEach(video => {
        if (!this.contains(video)) video.pause();
      });
    }
    play() {
      this.pauseOthers();
      this.status.hidden = true;
      let video = this.mount.querySelector('video');
      if (this.desktopTemplate && !video) {
        const useMobile = window.matchMedia('(max-width: 599px)').matches && this.mobileTemplate;
        const template = useMobile ? this.mobileTemplate : this.desktopTemplate;
        this.mount.appendChild(template.content.cloneNode(true));
        video = this.mount.querySelector('video');
        if (!video) return;
        video.removeAttribute('autoplay');
        video.preload = 'none';
        video.controls = true;
        video.playsInline = true;
        video.tabIndex = 0;
        video.setAttribute('aria-label', this.dataset.videoTitle || 'Product video');
        video.addEventListener('play', () => this.pauseOthers());
        video.addEventListener('error', () => this.showError('This video is unavailable right now.'));
      }
      if (video) {
        this.idle.hidden = true;
        this.mount.hidden = false;
        video.focus();
        const playback = video.play();
        playback?.catch(() => this.showError('Use the video controls to start playback.'));
        return;
      }
      const source = this.externalSource();
      if (!source) return;
      const frame = document.createElement('iframe');
      frame.src = source;
      frame.title = this.dataset.videoTitle || 'Product video';
      frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      this.mount.replaceChildren(frame);
      this.idle.hidden = true;
      this.mount.hidden = false;
      frame.focus();
    }
    pause() {
      if (!this.mount) return;
      this.mount.querySelectorAll('video').forEach(video => video.pause());
      if (this.mount.querySelector('iframe')) {
        this.mount.replaceChildren();
        this.mount.hidden = true;
        this.idle.hidden = false;
      }
    }
    showError(message) {
      this.status.textContent = message;
      this.status.hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
